/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_One_FrameInputs */



/**
* | output |
* | --- |
* | "Go back one frame in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_One_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_one_frame = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_One_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_One_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer d'une image dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spule im Video ein Bild zurück.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna indietro di un fotogramma nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернитесь на один кадр назад в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceda un fotograma en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回到视频的上一帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを1フレーム戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में एक फ्रेम पीछे जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volte um fotograma no vídeo.")
	return /** @type {LocalizedString} */ ("Go back one frame in the video")
});